import { Component, HostBinding, inject, OnInit } from '@angular/core';
import { ButtonModule } from '@bcef/ia-components/buttons';
import { ConfirmationBannerComponent } from '@bcef/ia-components/confirmation-banner';
import { ContextService } from '@bcef/ia-shared';
import { DataLayered } from '@difa/ia-data-layer';
import { TranslateModule } from '@ngx-translate/core';

import { RoutesPath } from '@features/termination/enums';

import { TerminationFacade } from '../../termination.facade';

@DataLayered('screens.error.datalayer')
@Component({
  selector: 'ia-resil-contrats-error',
  templateUrl: './error.component.html',
  imports: [ButtonModule, TranslateModule, ConfirmationBannerComponent],
})
export class ErrorComponent implements OnInit {
  @HostBinding('class') public classAttribute = 'tw-block';

  private readonly terminationFacade: TerminationFacade = inject(TerminationFacade);

  private readonly contextService: ContextService = inject(ContextService);

  public ngOnInit(): void {
    this.terminationFacade.updateStepInProgress(0);
  }

  public onClick(): void {
    if (this.contextService.isMobile) {
      this.terminationFacade.closeWebView();
    } else {
      this.terminationFacade.navigateTo(RoutesPath.ONBOARDING_PAGE);
    }
  }
}
